<template>
  <AppButton
    id="submit-return"
    class="primary expanded margin-top-s large-margin-top-m"
    :disabled="returnItemStore.SUBMIT_DISABLED"
    :loading="loading"
    @click="submit()"
  >
    {{ submitCtaText }}
  </AppButton>
  <Notification v-if="returnItemStore.GET_ESTIMATED_REFUND_SUBMIT_ERROR" class="margin-top-m" severity="error" :closable="false">
    {{ returnItemStore.GET_ESTIMATED_REFUND_SUBMIT_ERROR }}
  </Notification>
  <div v-if="returnItemStore.SHOW_CONDITIONAL_RETURN_FEE" class="flex-container margin-top-m">
    <div class="margin-right-xxs">
      <span class="tooltip-large"></span>
    </div>
    <div>
      {{ STAR_REWARDS_CONTENT }}
      <p class="margin-top-xs">* Plus tax where applicable</p>
    </div>
  </div>
  <NeedHelp horizontal :show-phone-number="isBcom" :show-chat="isBcom" class="margin-top-s large-margin-top-m" />
</template>

<script setup>
import { computed } from 'vue';
import { fireTag } from '@vue-util/tagManager';
import Notification from '@nuxt-common/atomic-ui/app/components/notification/Notification.vue';
import AppButton from '@/components/AppButton';
import NeedHelp from '@/components/common/NeedHelp';
import { REFUND_METHOD } from 'config';
import { STAR_REWARDS_CONTENT } from '#shared/constants';
// Pinia Store & Composables
import { useReturnItemStore } from '@/stores/returns/useReturnItemStore';
import useBrand from '@/composables/useBrand';
const returnItemStore = useReturnItemStore();

const { isBcom } = useBrand();
const router = useRouter();
const route = useRoute();

// Computed properties
const loading = computed(
  () =>
    ![REFUND_METHOD.EXCHANGE, REFUND_METHOD.EXCHANGE].includes(returnItemStore.returnSelections.refundOption?.choice) &&
    returnItemStore.loading.submitReturnItems,
);
const submitCtaText = computed(() => {
  if (returnItemStore.returnSelections.refundOption?.choice === REFUND_METHOD.EXCHANGE) return 'Submit Exchange';
  if (returnItemStore.returnSelections.refundOption?.choice === REFUND_METHOD.REPLACEMENT) return 'Submit Replacement';
  return 'Submit Return';
});

// Method for submission
const submit = async () => {
  fireTag('link', {
    event_name: 'submit return',
    link_name: 'submit return',
  });

  await returnItemStore.SUBMIT_RETURN_ITEMS({
    router,
    upcNumber: route.query.upcnumber,
  });
};
</script>
